export default "/images/vendor/flag-icons/flags/4x3/na.svg?7e46f9f6fb3767adf481746d18a6103c";